<template>
	<div class="page">
		<div class="logo">
			<div style="display: grid;place-items: center;">
				<img class="img"
					src="https://hzkj-college.oss-cn-shenzhen.aliyuncs.com/college/product/file/2024-09-29/logo.png?Expires=2358318752&OSSAccessKeyId=LTAI6wVHwVUutPzc&Signature=oZywJyWSpcgBKRN%2FPOU3%2FYjSRoo%3D"
					alt="" />
				<p class="t-b">{{title}}</p>
			</div>
		</div>
		<div class="form userform">
			<div class="code">
				<el-input class="phoneinput" type="number" v-model="phoneNumber" placeholder="请输入手机号"></el-input>
			</div>
			<div class="username">
				<div class="get-code" :style="{'color':getCodeBtnColor}" @click.stop="getCode()">{{getCodeText}}</div>
				<el-input class="verficationinput" v-model="VerificationCode" placeholder="请输入验证码"></el-input>
			</div>
			<div class="btn" @click="submit">登 录</div>
		</div>
	</div>
</template>

<script>
	import NavBar from "../../src/components/navBar.vue";
	import {
		h5login,
		sendCode
	} from "../../src/request/api.js";
	export default {
		components: {
			NavBar,
		},
		data() {
			return {
				title: '弘知教育签到系统_1.0',
				phoneNumber: '',
				VerificationCode: '',
				getCodeText: '获取验证码',
				getCodeBtnColor: "rgba(88, 176, 246, 1)",
				getCodeisWaiting: false
			}
		},
		methods: {
			//获取手机验证码方法
			getCode() {
				if (this.getCodeisWaiting) {
					return;
				}
				if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNumber))) { //校验手机号码是否有误
					this.$message({
						message: '请填写正确手机号码',
						type: 'warning',
					});
					return false;
				}
				this.getCodeText = "发送中..." //发送验证码
				this.getCodeisWaiting = true;
				this.getCodeBtnColor = "#C8C8C8" //追加样式，修改颜色
				//示例用定时器模拟请求效果
				//setTimeout(()用于在指定的毫秒数后调用函数或计算表达式
				setTimeout(() => {
					this.$message({
						message: '验证码已发送',
						type: 'none',
					});
					sendCode('phone=' + this.phoneNumber).then((res) => {});
					this.setTimer(); //调用定时器方法
				}, 1000)
			},
			setTimer() {
				let holdTime = 60; //定义变量并赋值
				this.getCodeText = "重新获取(60)"
				//setInterval（）是一个实现定时调用的函数，可按照指定的周期（以毫秒计）来调用函数或计算表达式。
				//setInterval方法会不停地调用函数，直到 clearInterval被调用或窗口被关闭。
				this.Timer = setInterval(() => {
					if (holdTime <= 0) {
						this.getCodeisWaiting = false;
						this.getCodeBtnColor = "rgba(88, 176, 246, 1)";
						this.getCodeText = "获取验证码"
						clearInterval(this.Timer); //清除该函数
						return; //返回前面
					}
					this.getCodeText = "重新获取(" + holdTime + ")"
					holdTime--;
				}, 1000)
			},
			// // 提交按钮
			submit() {
				if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNumber))) { //校验手机号码是否有误
					this.$message({
						message: '请填写正确手机号码',
						type: 'warning',
					});
					return false;
				}
				if (!this.VerificationCode) { //验证码是否存在
					this.$message({
						message: '请输入验证码',
						type: 'warning',
					});
					return false;
				}
				h5login('phone=' + this.phoneNumber + '&code=' + this.VerificationCode).then((res) => {
					if (res.data.code === 0) {
						console.log(res.data)
						localStorage.setItem("token", res.data.msg)
						this.$router.push({
							name: "myschedule"
						}) //登录验证成功路由实现跳转
						this.$message({
							message: '登录成功',
							type: 'success',
						})
					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning',
						})
					}
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	// 改变input里的字体颜色
	/deep/input::-webkit-input-placeholder {
		color: #c1c1c1;
		font-size: 16px;
	}
</style>


<style lang="scss">
	.page {
		background: #D3EAFC; //整一个页面的背景颜色
		height: 100vh;
	}

	.logo {
		width: 100%;
		height: 70vw;
		display: flex;
		justify-content: center;
		align-items: center;

		.img {
			width: 90px;
			height: 90px;
			border-radius: 100%;
		}

		.t-b {
			text-align: center;
			color: rgba(79, 174, 246, 1);
			font-size: 24px;
			letter-spacing: 1.184000015258789px;
			font-family: PingFangSC-Semibold;
			font-weight: 600;
			white-space: nowrap;
			margin-top: 17px;
		}
	}

	.form {
		width: 92%;
		padding: 0 4%;
		font-size: 16px;

		.username,
		.code {
			display: flex;
			align-items: center;
			border-radius: 20px;
			background-color: #fff;
			padding: 0 20px;
			margin-bottom: 30px;

			.phoneinput {
				width: 100%;
				border: 0px;

				input {
					border: 0px;
					color: #333333;
					font-size: 17px;
					font-weight: 700;
				}
			}

			.verficationinput {
				width: 100%;
				border: 0px;

				input {
					border: 0px;
					color: #4FAEF6;
					font-size: 17px;
					font-weight: 700;
				}
			}



		}

		.btn {
			color: #fff;
			width: 100%;
			margin-top: 50px;
			height: 45px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 20px;
			background: linear-gradient(90deg, #3B7FEE 0%, #87BDFD 100%);
			border-radius: 29px;
		}
	}

	.username {
		position: relative;

		.get-code {
			position: absolute;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			right: 0;
			padding: 0 20px;
			z-index: 3;

			&:after {
				//点击以后，左边出现白色的线
				content: " ";
				width: 1px; //宽度为1px
				height: 20px; //高度为50px
				background-color: #fff; //背景颜色为白色
				position: absolute;
				z-index: 3;
				margin-right: 100%;
				left: 0;
				top: 10px;
			}
		}
	}
</style>